import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { DataGridPro, GridColumns, GridRowsProp } from '@mui/x-data-grid-pro';
import { getDataGridLocales } from 'services/localization/getDataGridLocales';
import { useTranslation } from 'services/localization';

interface Props {
	rows: GridRowsProp;
	columns: GridColumns;
}

const BaseImportTable = (props: Props) => {
	const { rows, columns } = props;
	const classes = useStyles();
	const { t } = useTranslation();

	return (
		<div className={classes.tableWrapper}>
			<DataGridPro
				className={classes.datagridRoot}
				density="standard"
				rows={rows}
				columns={columns}
				localeText={getDataGridLocales(t)}
				disableColumnReorder={true}
				disableSelectionOnClick={true}
				disableColumnMenu={true}
				hideFooter={true}
			/>
		</div>
	);
};

const useStyles = makeStyles((theme) => ({
	tableWrapper: {
		height: 400,
		width: '100%',
		border: `1px solid ${theme.palette.border.paper}`,
	},
	datagridRoot: {
		backgroundColor: theme.palette.background.paper,
		border: 'none',
		'& .MuiDataGrid-columnHeaders': {
			backgroundColor: theme.palette.background.secondary,
		},
		'& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
			outline: 'none',
		},
		'& .MuiDataGrid-columnSeparator': {
			color: theme.palette.border.table,
		},
		'& .MuiDataGrid-cell': {
			border: 'none',
		},
		'& .MuiDataGrid-row': {
			borderBottom: `1px solid ${theme.palette.border.table}`,
			'& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus': {
				outline: 'none',
			},
		},
		'& .overflow-cell': {
			overflowX: 'auto',
		},
		'& .no-value-cell': {
			color: theme.palette.error.main,
			fontStyle: 'italic',
		},
		'& .invalid-cell': {
			border: `1px solid ${theme.palette.error.main}`,
		},
		'& .MuiDataGrid-columnHeaders + div': {
			//Forces scrollbar to table bottom
			minHeight: '100%',
		},
		'& .MuiDataGrid-virtualScroller': {
			//Forces scrollbar to table bottom
			minHeight: 'calc(100% - 56px) !important',
		},
	},
}));

export default BaseImportTable;
